import createDebug from 'debug';

type DebugLogger = (...args: unknown[]) => void;

/** 用来作为开关 */
const debugNoStackTraceSwitch: (...args: unknown[]) => void = createDebug('Timeline:notrace');

function logWithStackTrace(logger: DebugLogger) {
  if (!debugNoStackTraceSwitch.enabled) {
    // eslint-disable-next-line
    logger.log = console.trace.bind(console);
  }

  return logger;
}

/** 调试主程序 */
export const debug = logWithStackTrace(createDebug('Timeline'));

export default debug;
